import { IBillingPaymentMethod } from './payment-widget-billing/payment-widget-billing.service';

export class PaymentFail {
  public message: string;
}

export class PaymentOptions {
  /** Имя плательщика */
  public first_name: string;

  /** Фамилия плательщика */
  public last_name: string;

  /** Email плательщика */
  public email: string;

  /** Телефон плательщика */
  public phone: string;

  /** ISO 3166-1 2-letter country code */
  public country: string;

  /** ID заказ для поиска неоплаченных начислений */
  public order_id?: string;

  /** ID конкретных начислений */
  public charge_id?: string[];

  /** Данные для поиска неоплаченных начислений */
  public meta?: { [key: string]: string | number };
}

export class PaymentConfiguration {
  public paymentMethod?: IBillingPaymentMethod;
  public provider_id: string;
  public complete: boolean;
}
